<toast-notification #toastNotification></toast-notification>

  <!-- Sub-tabs: Loc Management / Loc Group Management -->
  <div class="acs-subtabs">
    <button class="acs-subtabs__tab" [class.acs-subtabs__tab--active]="activeSubTab === 'loc'"
            (click)="switchSubTab('loc')">Trade Unit Management</button>
    <button class="acs-subtabs__tab" [class.acs-subtabs__tab--active]="activeSubTab === 'group'"
            (click)="switchSubTab('group')">Trade Unit Group Management</button>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!-- LOC MANAGEMENT TAB                      -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="activeSubTab === 'loc'" class="acs-row acs-row--gap-lg acs-split acs-split--short">
    <div class="acs-col--full acs-split__list">
      <!-- Toolbar -->
      <div class="acs-toolbar">
        <div class="acs-flex acs-flex--center acs-gap-md">
          <div class="acs-flex acs-flex--center">
            <i class="fa-solid fa-building acs-dropdown__icon" title="Trade Unit"></i>
            <div class="acs-dropdown" (click)="$event.stopPropagation()">
              <button type="button" class="acs-dropdown__trigger" (click)="toggleLocFilterDropdown()"
                      [class.acs-dropdown__trigger--placeholder]="!locFilter">
                {{locFilterDisplay}}
                <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
              </button>
              <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('tu-loc-filter')">
                <input class="acs-dropdown__search" type="text" placeholder="Search..."
                       [ngModel]="locFilterSearchText()" (ngModelChange)="locFilterSearchText.set($event)"
                       (click)="$event.stopPropagation()" />
                <div class="acs-dropdown__options">
                  <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                       (click)="selectLocFilterOption(null)">-- All Trade Units --</div>
                  <div *ngFor="let loc of filteredLocDropdownOptions"
                       class="acs-dropdown__option"
                       [class.acs-dropdown__option--selected]="loc.locCode === locFilter"
                       (click)="selectLocFilterOption(loc)">{{loc.locCode}} - {{loc.description}}</div>
                  <div *ngIf="filteredLocDropdownOptions.length === 0" class="acs-dropdown__empty">No matches</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="acs-toolbar__actions">
          <small class="acs-text-muted">{{filteredLocList.length}} trade unit(s)</small>
          <button type="button" class="acs-action-btn acs-action-btn--danger"
                  [disabled]="selectedLocCount === 0"
                  (click)="requestBulkDeleteLocs()">
            <i class="fa-solid fa-trash"></i> Delete<span *ngIf="selectedLocCount > 0"> ({{selectedLocCount}})</span>
          </button>
        </div>
      </div>
      <div class="acs-table-wrap acs-table-wrap--connected acs-split__list-body">
        <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered">
          <thead class="acs-thead--primary acs-sticky">
            <tr>
              <th class="acs-table__checkbox-col">
                <input type="checkbox" class="acs-table__checkbox"
                       [checked]="allVisibleLocsSelected && filteredLocList.length > 0"
                       (change)="toggleSelectAllLocs()">
              </th>
              <th>Trade Unit</th>
              <th>Co</th>
              <th>Div</th>
              <th>Description</th>
              <th style="width: 180px;">Default Group</th>
              <th>Groups</th>
              <th class="acs-text-center">Status</th>
              <th style="width: 160px;">Inactive Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let loc of filteredLocList">
              <td class="acs-table__checkbox-col" (click)="$event.stopPropagation()">
                <input type="checkbox" class="acs-table__checkbox"
                       [checked]="isLocSelected(loc.locCode)"
                       (change)="toggleLocSelect(loc.locCode, $event)">
              </td>
              <td>{{loc.locCode}}</td>
              <td>{{loc.company}}</td>
              <td>{{loc.division}}</td>
              <td>{{loc.description}}</td>
              <td>
                <div class="acs-dropdown" (click)="$event.stopPropagation()">
                  <button type="button" class="acs-dropdown__trigger"
                          (click)="toggleGroupDropdown(loc.locCode)"
                          [class.acs-dropdown__trigger--placeholder]="!loc.defaultGroupId"
                          style="width: 160px;">
                    {{getDefaultGroupDisplay(loc) || '-- None --'}}
                    <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
                  </button>
                  <div class="acs-dropdown__panel" *ngIf="isGroupRowDropdownOpen(loc.locCode)">
                    <input class="acs-dropdown__search" type="text" placeholder="Search..."
                           [ngModel]="groupDropdownSearchText()" (ngModelChange)="groupDropdownSearchText.set($event)"
                           (click)="$event.stopPropagation()" />
                    <div class="acs-dropdown__options">
                      <div class="acs-dropdown__option"
                           [class.acs-dropdown__option--selected]="!loc.defaultGroupId"
                           (click)="selectDefaultGroup(loc, null)">-- None --</div>
                      <div *ngFor="let g of filteredDefaultGroupOptions"
                           class="acs-dropdown__option"
                           [class.acs-dropdown__option--selected]="g.groupId === loc.defaultGroupId"
                           (click)="selectDefaultGroup(loc, g)">{{g.groupCode}} - {{g.groupName}}</div>
                      <div *ngIf="filteredDefaultGroupOptions.length === 0" class="acs-dropdown__empty">No matches</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>{{loc.groupCodes?.join(', ')}}</td>
              <td class="acs-text-center">
                <span class="acs-badge" [class.acs-badge--success]="isLocActive(loc)" [class.acs-badge--danger]="!isLocActive(loc)">
                  {{isLocActive(loc) ? 'Active' : 'Inactive'}}
                </span>
              </td>
              <td>
                <div class="acs-input-group" style="width: 160px;">
                  <input type="date" class="acs-input acs-input--inline"
                         [ngModel]="loc.inactiveDate ? (loc.inactiveDate | date:'yyyy-MM-dd') : null"
                         (change)="requestDeactivateChange(loc, $any($event.target).value || null)">
                  <button *ngIf="loc.inactiveDate" class="acs-btn acs-btn--outline-secondary"
                          type="button" (click)="requestDeactivateChange(loc, null)"
                          title="Clear inactive date">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

  <!-- ═══════════════════════════════════════ -->
  <!-- LOC GROUP MANAGEMENT TAB                -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="activeSubTab === 'group'" class="acs-row acs-row--gap-lg acs-split acs-split--short">
    <div class="acs-col--full acs-split__list">
      <!-- Toolbar -->
      <div class="acs-toolbar">
        <div class="acs-flex acs-flex--center acs-gap-md">
          <div class="acs-flex acs-flex--center">
            <i class="fa-solid fa-layer-group acs-dropdown__icon" title="Group"></i>
            <div class="acs-dropdown" (click)="$event.stopPropagation()">
              <button type="button" class="acs-dropdown__trigger" (click)="toggleGroupFilterDropdown()"
                      [class.acs-dropdown__trigger--placeholder]="!groupFilter">
                {{groupFilterDisplay}}
                <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
              </button>
              <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('tu-group-filter')">
                <input class="acs-dropdown__search" type="text" placeholder="Search..."
                       [ngModel]="groupFilterSearchText()" (ngModelChange)="groupFilterSearchText.set($event)"
                       (click)="$event.stopPropagation()" />
                <div class="acs-dropdown__options">
                  <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                       (click)="selectGroupFilterOption(null)">-- All Groups --</div>
                  <div *ngFor="let g of filteredGroupDropdownOptions"
                       class="acs-dropdown__option"
                       [class.acs-dropdown__option--selected]="g.groupCode === groupFilter"
                       (click)="selectGroupFilterOption(g)">{{g.groupCode}} - {{g.groupName}}</div>
                  <div *ngIf="filteredGroupDropdownOptions.length === 0" class="acs-dropdown__empty">No matches</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="acs-toolbar__actions">
          <small class="acs-text-muted">{{filteredGroupList.length}} group(s)</small>
          <button type="button" class="acs-action-btn acs-action-btn--danger"
                  [disabled]="bulkDeleteGroups.selectedCount === 0"
                  (click)="bulkDeleteGroups.requestDelete()">
            <i class="fa-solid fa-trash"></i> Delete<span *ngIf="bulkDeleteGroups.selectedCount > 0"> ({{bulkDeleteGroups.selectedCount}})</span>
          </button>
          <button type="button" class="acs-action-btn acs-action-btn--accent" (click)="addNewGroup()">
            <i class="fa-solid fa-plus"></i> Add Group
          </button>
        </div>
      </div>
      <div class="acs-table-wrap acs-table-wrap--connected acs-split__list-body">
        <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered">
          <thead class="acs-thead--primary acs-sticky">
            <tr>
              <th class="acs-table__checkbox-col">
                <input type="checkbox" class="acs-table__checkbox"
                       [checked]="bulkDeleteGroups.allVisibleSelected && filteredGroupList.length > 0"
                       (change)="bulkDeleteGroups.toggleSelectAll()">
              </th>
              <th>Group</th>
              <th>Group Name</th>
              <th>Deactivate On</th>
              <th class="acs-text-center">Status</th>
              <th>Loc Codes</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let group of filteredGroupList" (click)="selectGroup(group)" class="acs-cursor-pointer"
                [class.acs-tr--active]="selectedGroup?.groupId === group.groupId"
                [class.acs-bold]="selectedGroup?.groupId === group.groupId">
              <td class="acs-table__checkbox-col" (click)="$event.stopPropagation()">
                <input type="checkbox" class="acs-table__checkbox"
                       [checked]="bulkDeleteGroups.isSelected(group.groupId)"
                       (change)="bulkDeleteGroups.toggle(group.groupId, $event)">
              </td>
              <td>{{group.groupCode}}</td>
              <td>{{group.groupName}}</td>
              <td>{{group.inactiveDate ? (group.inactiveDate | date:'yyyy-MM-dd') : ''}}</td>
              <td class="acs-text-center">
                <span class="acs-badge" [class.acs-badge--success]="isGroupActive(group)" [class.acs-badge--danger]="!isGroupActive(group)">
                  {{isGroupActive(group) ? 'Active' : 'Inactive'}}
                </span>
              </td>
              <td>{{group.locCodes?.join(', ')}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

  <!-- Group Detail Modal -->
  <div *ngIf="showForm && activeSubTab === 'group'" class="acs-modal" tabindex="-1">
    <div class="acs-modal__dialog acs-modal__dialog--lg">
      <div class="acs-modal__content">
        <div class="acs-modal__header">
          <h6 class="acs-modal__title">{{isEditingGroup ? formGroupCode + ' — ' + formGroupName : 'New Group'}}</h6>
          <button type="button" class="acs-btn--close" (click)="cancelGroupForm()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="acs-modal__body">
          <div class="acs-section-title">Group Details</div>
          <div class="acs-row acs-mb-2">
            <div class="acs-col--md6">
              <label class="acs-label">Group Code <small class="acs-text-muted">({{formGroupCode?.length || 0}}/10)</small></label>
              <input type="text" class="acs-input acs-text-uppercase" [(ngModel)]="formGroupCode"
                     maxlength="10" (input)="onGroupCodeInput()"
                     [readonly]="isEditingGroup">
            </div>
            <div class="acs-col--md6">
              <label class="acs-label">Group Name <small class="acs-text-muted">({{formGroupName?.length || 0}}/50)</small></label>
              <input type="text" class="acs-input" [(ngModel)]="formGroupName"
                     maxlength="50" (input)="onGroupNameInput()">
            </div>
          </div>
          <div class="acs-row acs-mb-2">
            <div class="acs-col--md6">
              <label class="acs-label">Deactivate On</label>
              <div class="acs-input-group">
                <input type="date" class="acs-input" [(ngModel)]="formInactiveDate">
                <button *ngIf="formInactiveDate" class="acs-btn acs-btn--outline-secondary"
                        type="button" (click)="clearGroupInactiveDate()">
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Loc Assignments -->
          <div class="acs-section-divider">
            <div class="acs-section-title">Trade Unit Assignments</div>
            <div class="acs-flex acs-flex--between acs-flex--center acs-mb-2">
              <h6 class="acs-small acs-bold acs-mb-0">Add Trade Unit</h6>
              <button type="button" class="acs-action-btn acs-action-btn--danger acs-action-btn--sm"
                      [disabled]="selectedAssignedLocCount === 0"
                      (click)="requestRemoveAssignedLocs()">
                <i class="fa-solid fa-trash"></i> Remove<span *ngIf="selectedAssignedLocCount > 0"> ({{selectedAssignedLocCount}})</span>
              </button>
            </div>
            <div class="acs-pos-rel acs-mb-2">
              <input type="text" class="acs-input"
                     placeholder="Search trade units..."
                     [(ngModel)]="locSearchTerm"
                     (click)="$event.stopPropagation()"
                     (focus)="showLocDropdown = true"
                     (input)="showLocDropdown = true">
              <div *ngIf="showLocDropdown && filteredLocs.length > 0"
                   class="acs-pos-abs acs-w-full acs-border acs-bg-white acs-shadow-sm acs-assign-dropdown"
                   (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation()">
                <div *ngFor="let loc of filteredLocs"
                     class="acs-assign-dropdown__option"
                     [class.acs-assign-dropdown__option--selected]="isPendingLoc(loc.locCode)"
                     (click)="togglePendingLoc(loc)">
                  <span class="acs-check-icon" [class.acs-check-icon--checked]="isPendingLoc(loc.locCode)"></span>
                  {{loc.locCode}} - {{loc.description}}
                </div>
                <div *ngIf="pendingLocCount > 0" class="acs-assign-dropdown__footer">
                  <button class="acs-btn acs-btn--primary acs-btn--sm" (click)="addPendingLocsToGroup()">
                    Add {{pendingLocCount}} Trade Unit(s)
                  </button>
                </div>
              </div>
            </div>
            <div class="acs-assign-scroll">
              <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered acs-mb-0">
                <thead class="acs-thead--primary acs-sticky">
                  <tr>
                    <th class="acs-table__checkbox-col">
                      <input type="checkbox" class="acs-table__checkbox"
                             [checked]="allAssignedLocsSelected && assignedLocs.length > 0"
                             (change)="toggleSelectAllAssignedLocs()">
                    </th>
                    <th>Trade Unit</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let loc of assignedLocs">
                    <td class="acs-table__checkbox-col" (click)="$event.stopPropagation()">
                      <input type="checkbox" class="acs-table__checkbox"
                             [checked]="isAssignedLocSelected(loc.locCode)"
                             (change)="toggleAssignedLocSelect(loc.locCode)">
                    </td>
                    <td class="acs-small">{{loc.locCode}}</td>
                    <td class="acs-small">{{loc.description}}</td>
                  </tr>
                </tbody>
              </table>
              <div *ngIf="assignedLocs.length === 0" class="acs-empty-state">
                <i class="fa-solid fa-building"></i>
                No trade units assigned
              </div>
            </div>
          </div>
        </div>
        <div class="acs-modal__footer">
          <button class="acs-btn acs-btn--secondary" (click)="cancelGroupForm()">Cancel</button>
          <button class="acs-btn acs-btn--primary" (click)="saveGroup()">
            {{isEditingGroup ? 'Update' : 'Save'}}
          </button>
        </div>
      </div>
    </div>
  </div>

<!-- Activate/Inactivate Confirmation Dialog -->
<div *ngIf="showDeactivateConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Status Change</h6>
        <button type="button" class="acs-btn--close" (click)="cancelDeactivateChange()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p *ngIf="pendingDeactivateDate">Set inactive date for <strong>{{pendingDeactivateLoc?.locCode}}</strong>? This will deactivate the trade unit.</p>
        <p *ngIf="!pendingDeactivateDate">Clear inactive date for <strong>{{pendingDeactivateLoc?.locCode}}</strong>? This will reactivate the trade unit.</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="cancelDeactivateChange()">Cancel</button>
        <button class="acs-btn acs-btn--primary" (click)="confirmDeactivateChange()">Yes, Continue</button>
      </div>
    </div>
  </div>
</div>

<!-- Bulk Delete Loc Confirmation Dialog -->
<div *ngIf="showBulkDeleteLocConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Delete</h6>
        <button type="button" class="acs-btn--close" (click)="cancelBulkDeleteLocs()" [disabled]="isBulkDeletingLocs">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Delete <strong>{{selectedLocCount}}</strong> trade unit(s)? This action cannot be undone.</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="cancelBulkDeleteLocs()" [disabled]="isBulkDeletingLocs">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmBulkDeleteLocs()" [disabled]="isBulkDeletingLocs">
          {{isBulkDeletingLocs ? 'Deleting...' : 'Yes, Delete'}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Remove Assigned Locs Confirmation Dialog -->
<div *ngIf="showRemoveLocConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Remove</h6>
        <button type="button" class="acs-btn--close" (click)="cancelRemoveAssignedLocs()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Remove <strong>{{selectedAssignedLocCount}}</strong> trade unit(s) from this group?</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="cancelRemoveAssignedLocs()">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmRemoveAssignedLocs()">Yes, Remove</button>
      </div>
    </div>
  </div>
</div>

<!-- Bulk Delete Group Confirmation Dialog -->
<div *ngIf="bulkDeleteGroups.showConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Delete</h6>
        <button type="button" class="acs-btn--close" (click)="bulkDeleteGroups.cancelDelete()" [disabled]="bulkDeleteGroups.isDeleting">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Delete <strong>{{bulkDeleteGroups.selectedCount}}</strong> group(s)? This action cannot be undone.</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="bulkDeleteGroups.cancelDelete()" [disabled]="bulkDeleteGroups.isDeleting">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmBulkDeleteGroups()" [disabled]="bulkDeleteGroups.isDeleting">
          {{bulkDeleteGroups.isDeleting ? 'Deleting...' : 'Yes, Delete'}}
        </button>
      </div>
    </div>
  </div>
</div>

